import DataGridComponent from "components/DataGridComponent/DataGridComponent"
import { DeleteDialog } from "components/DeleteDialog/DeleteDialog"
import { Laboratory } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { AddLaboratoriesDialog } from "./AddLaboratoriesDialog"

export const laboratoryEmpty: Laboratory = {
  id: "NEW",
  name: "",
  manager: "",
}

const AdminLaboratories = () => {
  const { laboratories, employees } = useStoreState((state) => state)
  const { updateLaboratory, deleteLaboratory, fetchLaboratories } =
    useStoreActions((actions) => actions)
  const { fetchEmployees } = useStoreActions((actions) => actions)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formState, setFormState] = useState<Laboratory>(laboratoryEmpty)
  const [openDelete, setOpenDelete] = useState(false)
  const [toDelete, setToDelete] = useState<string[]>([])

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([fetchLaboratories(), fetchEmployees()])
    }
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleEdit = (id: string) => {
    if (id === "NEW") {
      setFormState({
        ...laboratoryEmpty,
        id: "NEW",
      })
    } else {
      const lab = laboratories.find((tb) => tb.id === id)
      if (lab) {
        setFormState(lab)
      }
    }
    setDialogOpen(true)
  }

  const handleDelete = (id: string[]) => {
    setOpenDelete(true)
    setToDelete(id)
  }

  const handleDeleteSelected = () => {
    deleteLaboratory(toDelete)
    setToDelete([])
    setOpenDelete(false)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  const handleFormSubmit = (arg: Laboratory) => {
    updateLaboratory(arg)
    setDialogOpen(false)
  }

  const columns = [
    { field: "name", headerName: "Bezeichnung", flex: 300 },

    {
      field: "manager",
      headerName: "Laborleiter",
      flex: 150,
      valueGetter: (value: string) => {
        const employee = employees.find((e) => e.id === value)
        return employee?.EmployeeName
      },
    },
  ]

  return (
    <>
      <DataGridComponent
        columns={columns}
        rows={laboratories}
        getRowId={(row) => row.id}
        onEdit={handleEdit}
        onAdd={() => handleEdit("NEW")}
        onDelete={handleDelete}
      />

      <AddLaboratoriesDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        formState={formState}
        onSubmit={handleFormSubmit}
      />

      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteSelected}
      />
    </>
  )
}

export default AdminLaboratories
